import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExternalSystemSyncExecution  {
    _originalTypeClassName = "zERP.BO.ExternalSystemSyncExecution";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExternalSystemSyncExecution.translate = translateService;
}
this.Logs = [];
this.Id = null;
this.ExecutedOn = null;
this.FinishedOn = null;
this.Status = null;
this.DocumentType = null;
this.SyncedItems = null;
this.StartingId = null;
this.EndingId = null;
this.DateFrom = null;
this.DateTo = null;
this.ForCustomPeriod = false;
this.ExecutedByUserName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ExecutedOn:any;
FinishedOn:any;
Status:any;
DocumentType:any;
SyncedItems:any;
StartingId:any;
EndingId:any;
DateFrom:any;
DateTo:any;
ForCustomPeriod:any;
ExecutedByUserName:any;
Logs:any;
ExecutedBy:any;
static setLogs = ($this, items) => {
                if (items == null) items = [];
                if ($this.Logs == null) $this.Logs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Logs.length > 0) {
                    Domain.ExternalSystemSyncExecution.removeLogs($this, $this.Logs[0]);
                }

                Domain.ExternalSystemSyncExecution.addManyLogs($this, copyItems);
            }
static addManyLogs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExternalSystemSyncExecution.addLogs($this, items[i]);
                }
            }
static addLogs = ($this, item) => {
                if ($this.Logs == null) $this.Logs = [];
                if (item == null || $this.Logs.indexOf(item) > -1) return;
                $this.Logs.push(item);
if (item.Execution != $this) {
Domain.ExternalSystemSyncLogEntry.setExecution(item, $this);
}
}
static addRangeLogs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExternalSystemSyncExecution.addLogs($this, item));
            }
static removeLogs = ($this, item) => {
                if ($this == null || $this.Logs == null || $this.Logs.indexOf(item) === -1) return;
                var _index = $this.Logs.indexOf(item);
                $this.Logs.splice(_index, 1);
item.Execution = null;
}
static clearLogs = ($this) => { $this.Logs = null; }
static setExecutedBy = ($this, value) => {
var oldValue = $this.ExecutedBy;
$this.ExecutedBy = value;
if (value != null) {
}
}

static GetClassName(): any{return "ExternalSystemSyncExecution";
}
static Init(config: any,dateFrom: any,dateTo: any): any{let execution = new Domain.ExternalSystemSyncExecution();
execution.ForCustomPeriod = !(Domain.DateHelper.IsDateNull(dateFrom)) && !(Domain.DateHelper.IsDateNull(dateTo));
execution.ExecutedOn = moment().toDate();
Domain.ExternalSystemSyncExecution.setExecutedBy(execution, Domain.UserAccount.GetActive());
execution.DocumentType = config?.DocumentType;
execution.SyncedItems = 0;
execution.Status = Domain.ExternalSystemSyncResult.InProgress;
let lastSyncedId = config?.LastSyncId;
let lastSyncedDate = config?.LastSyncDate;
if (lastSyncedDate == null || (new Date(lastSyncedDate).getTime()) == (new Date().getTime())) {lastSyncedDate = (moment((moment(moment().toDate()).add(-1, "y")).toDate()).add(1, "d")).toDate();}
if (execution?.ForCustomPeriod) {execution.StartingId = "";execution.DateFrom = dateFrom;execution.DateTo = dateTo;}else {execution.StartingId = lastSyncedId;execution.DateFrom = lastSyncedDate;if (config?.DocumentType == Domain.BackOfficeDocumentType.DailyRegister) {execution.DateTo = (moment(lastSyncedDate).add(1, "d")).toDate();}else {execution.DateTo = (moment(lastSyncedDate).add(1, "M")).toDate();}}
if ((new Date(execution?.DateTo).getTime()) > (new Date(moment().toDate()).getTime())) {execution.DateTo = moment().toDate();}
return execution;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}